"use client";

import React from "react";

import classNames from "classnames";

import { SectionTitle } from "../section-title";

import {
  ClusterSummaryMetricCard,
  type ClusterSummaryMetricCardProps,
} from "./cluster-summary-metric-card";

interface ClusterSelectionSummaryProps {
  metrics: ClusterSummaryMetricCardProps[];
}

const ClusterSelectionSummaryComponent: React.FC<ClusterSelectionSummaryProps> = ({
  metrics,
}) => {
  const isSingleMetric = metrics.length === 1;

  return (
    <div>
      <SectionTitle title="Summary" />
      <div className={classNames("mt-2", { "grid grid-cols-2 gap-2": !isSingleMetric })}>
        {metrics.map((metric) => (
          <ClusterSummaryMetricCard
            key={metric.label}
            className={isSingleMetric ? "w-[151px]" : undefined}
            icon={metric.icon}
            label={metric.label}
            value={metric.value}
          />
        ))}
      </div>
    </div>
  );
};

export const ClusterSelectionSummary = React.memo(ClusterSelectionSummaryComponent);
